import React from 'react'
import ModuleOverviewPage from 'pages/modules/ModuleOverviewPage'
import { MODULE_CONFIGS } from 'pages/modules/moduleConfigs'

const ReportsListPage = () => <ModuleOverviewPage {...MODULE_CONFIGS.reports} />

export default ReportsListPage
